/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.IMAGES_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.images,
                (memo, images) => {
                    const { id } = images;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = images;

                    return memo;
                },
                state,
            );
        },
    },
);